<template>
<div class="modal-card" style="width: 650px">
    <header class="modal-card-head">
        <p v-if="file.docId" class="modal-card-title">Manage File</p>
        <p v-else class="modal-card-title">Add File</p>
        <!-- <div class="columns">
            <div class="column">
                <div>
                    <b-switch type="is-success" v-model="user.active"></b-switch>
                </div>
            </div>
        </div> -->
    </header>
    <section class="modal-card-body">
        <!--   //////////////////////////////////////////////////////// -->
        <div class="card-content">
            <div class="columns">
                <div class="column">
                    <b-field label="File Type">
                        <b-select placeholder="Select a name" v-model="file.fileType" expanded>
                            <option value="video">
                                Video <i style="color:red" class="fab fa-youtube"></i>
                            </option>
                            <option value="pdf">
                                PDF Document
                            </option>
                        </b-select>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="File Title">
                        <b-input v-model="file.title" placeholder="PDF 1">

                        </b-input>
                    </b-field>
                </div>
            </div>

            <div>
                <b-field label="Video Id">
                    <b-input v-model="file.url" placeholder="https://www.youtube.com/watch?v=tq6aGrvxR-A">

                    </b-input>
                </b-field>
                <b-field label="Video OTP">
                    <b-input v-model="file.otp" placeholder="https://www.youtube.com/watch?v=tq6aGrvxR-A">

                    </b-input>
                </b-field>

            </div>

            <div class="columns" style="margin-top:1rem;">
                <div class="column">
                    <b-field label="Priority">
                        <b-input v-model="file.priority" placeholder="1">

                        </b-input>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Is Free ?">
                        <b-switch v-model="file.free" placeholder="PDF 1">

                        </b-switch>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Active">
                        <b-switch v-model="file.active" placeholder="PDF 1">

                        </b-switch>
                    </b-field>
                </div>
            </div>
            <!-- <div class="ql-editor" v-html="file.content"></div> -->
            <vue-editor v-model="file.content"></vue-editor>

            <div>
                <center>
                    <b-field>
                        <b-upload v-model="dropFiles" type="is-info" drag-drop>
                            <section class="section" style="c width:100%">
                                <div class="content has-text-centered" style="color:black; width:100%">
                                    <p>
                                        <b-icon icon="upload" size="is-large">
                                        </b-icon>
                                    </p>
                                    <p>Drop your files here or click to upload</p>
                                </div>
                            </section>
                        </b-upload>

                    </b-field>
                    <b-tag type="is-link" size="is-medium" v-if="dropFiles">
                        <div class="subtitle" style="color:white">
                            {{ dropFiles.name }}
                        </div>
                    </b-tag>

                </center>

            </div>
        </div>
        <!-- /////////////////////////////////////////////// -->
    </section>
    <footer class="modal-card-foot">
        <button class="button is-black full-width-button" style=" width: 100%;  color:white" :class="{'is-loading': isLoading}" @click="manageFiles(file)">Save</button>
    </footer>
</div>
</template>

<script>
import ChapterService from './service';
import UploadService from '../../lib/UploadService';
/* import GroupService from '../settings/service' */
import Firebase from '../../lib/Firebase';
import Firestore from '../../lib/Firestore';
// import { VueEditor } from "vue2-editor/dist/vue2-editor.core.js";
import {
    VueEditor
} from "vue2-editor";
export default {

    name: 'addUser',
    props: ['propFile', 'chapter', 'array'],
    components: {
        VueEditor,
    },

    created() {
        /* this.fetchGroups(); */
        if (this.propFile.docId) {
            this.file = {
                ...this.propFile
            };
        }
        console.log(this.file)

    },

    data() {
        return {
            isLoading: false,
            file: {
                url: null,
                title: null,
                fileType: 'video',
                priority: null,
                free: false,
                active: true,
                otp: null,
                fileUrl: null,
                content: ''

            },
            fileType: null,
            dropFiles: null
        };
    },

    methods: {

        manageFiles(file) {
            this.isLoading = true;
            console.log(file)
            if (file.fileType == 'video') {
                let videoFile = {
                    uploadedAt: new Date(),
                    ...file
                }
                //this.chapter.files.push(videoFile)
                ChapterService.manage(file.docId, this.chapter, videoFile).then(() => {
                    this.isLoading = false;
                    this.$buefy.toast.open("Saved successfully");
                    this.$emit("close");
                });

                if (this.dropFiles) {
                    UploadService(this.dropFiles, 'course', this.chapter.docId, file.title, this.chapter.title + '/' + file.title)
                        .then(() => {
                            this.isLoading = false;
                            this.$buefy.toast.open('File saved successfully');
                        })
                        .catch(() => {
                            this.isLoading = false;
                            this.$buefy.toast.open('Error saving image');
                        });
                    this.isLoading = false;
                    this.$buefy.toast.open("Saved successfully");

                    this.$emit("close");
                }
                // this.isLoading = false;
                // this.$buefy.toast.open("Saved successfully");
                // // this.array.push(videoFile);
                // this.$emit("close");
            }
        },
        /*     a(file) {
                this.isLoading = true;

               
            }, */
    },
    /* computed: {
            filteredDataArray() {
          
                 return this.data.filter((option) => {
                     return option
                         .toString()
                         .toLowerCase()
                         .indexOf(this.user.state.toLowerCase()) >= 0
                 })
             },
             filteredDataArraychapter() {
          
                 return this.districts.filter((option) => {
                     return option
                         .toString()
                         .toLowerCase()
                         .indexOf(this.user.chapter.toLowerCase()) >= 0
                 })
             }

         } */
};
</script>

<style>
@import "~vue2-editor/dist/vue2-editor.css";
/* Import the Quill styles you want */
@import "~quill/dist/quill.core.css";
@import "~quill/dist/quill.bubble.css";
@import "~quill/dist/quill.snow.css";

.zipcode-container {
    display: flex;
    justify-content: space-between;
}

.pan-image {
    height: 270px;
}
</style>



// WEBPACK FOOTER //
// src/pages/course/addFiles.vue